export default "__VITE_ASSET__9v7wkEY9__"